import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "nav-item__icon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "nav-item__label" }, "Home", -1)
const _hoisted_4 = { class: "nav-item__icon" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "About Me", -1)
const _hoisted_6 = { class: "nav-item__icon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "nav-item__label" }, "Portfolio", -1)
const _hoisted_8 = { class: "nav-item__icon" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "nav-item__label" }, "Qualifications", -1)
const _hoisted_10 = { class: "nav-item__icon" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "nav-item__label" }, "Message Me", -1)
const _hoisted_12 = { class: "nav-item__icon" }
const _hoisted_13 = { class: "nav-item__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BNavbarBrand = _resolveComponent("BNavbarBrand")!
  const _component_BNavbarToggle = _resolveComponent("BNavbarToggle")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BNavItem = _resolveComponent("BNavItem")!
  const _component_BNavbarNav = _resolveComponent("BNavbarNav")!
  const _component_BCollapse = _resolveComponent("BCollapse")!
  const _component_BContainer = _resolveComponent("BContainer")!
  const _component_BNavbar = _resolveComponent("BNavbar")!

  return (_openBlock(), _createBlock(_component_BNavbar, {
    toggleable: "lg",
    type: "light"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BContainer, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_BNavbarBrand, { to: "/" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.logo,
                alt: "TomAldy Logo",
                class: "mt-0 mt-lg-2 mb-2"
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_BNavbarToggle, {
            target: "nav-collapse",
            class: "navigation-button"
          }),
          _createVNode(_component_BCollapse, {
            id: "nav-collapse",
            "is-nav": "",
            class: "navigation"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BNavbarNav, null, {
                default: _withCtx(() => [
                  _createVNode(_component_BNavItem, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('home')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-duotone fa-house" })
                      ]),
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BNavItem, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('about-me')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-duotone fa-user" })
                      ]),
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BNavItem, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('portfolio')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-duotone fa-folder" })
                      ]),
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BNavItem, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('qualifications')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-duotone fa-graduation-cap" })
                      ]),
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BNavItem, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('message-me')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-duotone fa-paper-plane" })
                      ]),
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BNavItem, { onClick: _ctx.switchDarkMode }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_FontAwesomeIcon, { icon: _ctx.navigationIcon }, null, 8, ["icon"])
                      ]),
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.navigationLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}